import { recorded_content_media_types } from "./recordedContent";
import { schedule_types_ids, schedule_type_names } from "./schedule";
import { DEFAULT_TIME_FORMAT_12 } from "./dateTime";
import { GST_STATUS_CONSTS } from "features/Listings/modules/PricingSection/PricingSection.constants";
import {
  max_domestic_autodebit_price,
  max_domestic_price,
  max_international_price,
  min_domestic_autodebit_price,
  no_schedule_course_end_choices,
  offering_availability_statuses,
} from "features/Listings/Listings.constants";
import {
  PER_PAGE_OPTIONS_100,
  PER_PAGE_OPTIONS_250,
  PER_PAGE_OPTIONS_50,
} from "features/Common/constants/ExlyTableConstants";
import { address_type_enum } from "features/Listings/constants/Listings.constants";
import { GST_PERCENTAGE } from "features/Payment/constants/Payment.constants";

const constants = {
  address_type: [
    "Google Meet (link auto-generated on booking)",
    "Online Meeting Link (Zoom, Meet, Skype etc.)",
    "At my personal address",
    "At customer's address",
    "Zoom (link auto-generated on booking)",
    "Phone",
    "Whatsapp",
    "Exly Zoom",
    "Zoom Webinar",
    "None",
    "Exly Zoom Webinar",
  ],
  address_type_enum: address_type_enum,
  availability_status: offering_availability_statuses,
  facebook_share_url: `https://www.facebook.com/dialog/feed?app_id=${process.env.REACT_APP_FACEBOOK_APP_ID}`,
  null_display_image: "/static/img/default.png",
  GST_PERCENTAGE: GST_PERCENTAGE,
  customer_address: "At customer's own address",
  customer_location: "At customer's address",
  personal: "At my personal address",
  meet: "meet",
  zoom: "zoom",
  whatsapp: "Whatsapp",
  phone: "Phone",
  drive: "drive",
  existing_link: "Online Meeting Link (Zoom, Meet, Skype etc.)",
  zoom_webinar: "Zoom Webinar",
  seven_views: "7 day views",
  seven_views_info: "Page Views in last 7 days",
  seven_bookings: "7 day bookings",
  seven_bookings_info: "Last 7 days bookings",
  total_earnings_info:
    "Sum of all transactions made by the users while booking/purchasing your offerings",
  total_earnings: "Total Sales",
  total_bookings: "Total Bookings",
  total_bookings_info: "Total number of times users booked your offerings",
  views: "Views",
  views_info: "Total number of unique webpage views/visits",
  total_leads: "Total Leads",
  leads: "Leads",
  leads_info: "People who showed interest in booking your offerings",
  all_customers: "All Customers",
  all_customers_info: "People who booked your offerings",
  empty_image: "https://host.myscoot.in/static/img/default-event-image.png",
  default_schedule_image:
    "https://firebasestorage.googleapis.com/v0/b/scoot-staging-572e7.appspot.com/o/000000000000000000000_event_images%2Fcategory%2Fdefault%2Ftes.jpeg?alt=media&token=a4cb0783-5e41-4443-892f-7cafbdc9b201",
  mobile_width: 767,
  webpage_cover_height_desktop: 150,
  webpage_cover_height_mobile: 80,
  default_exly_domain: `glowandshow`,
  template: "template",
  paymentLink: "paymentLink",
  preview_ad_leads: "adLeads_preview.PNG",
  preview_gallery: "gallery_preview.png",
  preview_testimonial: "testimonial_preview.png",
  preview_payment_links_list: "payment_link_preview.PNG",
  preview_payment_links_create: "dynamic_schedules_preview.PNG",
  preview_booked_session: "session_preview.PNG",
  preview_all_transactions: "transaction_preview.PNG",
  preview_universal_transactions: "UniversalTransactions_preview.PNG",
  preview_subscriptions: "subscription_preview.PNG",
  preview_content_purchases: "preview_content_purchases.PNG",
  preview_team: "preview_teams.PNG",
  preview_merchandise: "preview_merchandise.PNG",
  preview_published_feedbacks: "PublishedFeedbacks_preview.png",
  preview_manage_feedback_forms: "ExlyManageFeedbackForms_preview.png",
  preview_user_referrals: "preview_user_referrals.png",
  preview_refer_a_friend: "refer_a_friend_preview.png",
  schedule_type: [
    {
      name: schedule_type_names[schedule_types_ids.one_on_one_appointment],
      id: schedule_types_ids.one_on_one_appointment,
      toast_description:
        "A schedule for 1 session meetings. The users choose and pay for each session.",
      share_text: "Join my session",
    },
    {
      name: schedule_type_names[schedule_types_ids.one_on_one_class],
      id: schedule_types_ids.one_on_one_class,
      toast_description:
        "Weekly repeating schedules for all your classes. Collect monthly or one-time payments.",
      share_text: "Join my class",
    },
    {
      name: schedule_type_names[schedule_types_ids.group_class],
      id: schedule_types_ids.group_class,
      toast_description:
        "Weekly repeating schedules for all your classes. Collect monthly or one-time payments.",
      share_text: "Join my class",
    },
    {
      name: schedule_type_names[schedule_types_ids.workshop],
      id: schedule_types_ids.workshop,
      toast_description:
        "Schedules for upcoming workshops happening on a fixed set of dates.",
      share_text: "Join my workshop",
    },
    {
      name: schedule_type_names[schedule_types_ids.no_schedule],
      id: schedule_types_ids.no_schedule,
      toast_description:
        "Payment collection pages for services with no specific schedules OR pages to sell Merchandise products for customers",
      share_text: "Buy my package",
    },
    {
      name: schedule_type_names[schedule_types_ids.content],
      id: schedule_types_ids.content,
      toast_description:
        "A package of recorded content or file links for your users to purchase",
      share_text: "Buy my content",
    },
    {
      name: schedule_type_names[schedule_types_ids.merchandise],
      id: schedule_types_ids.merchandise,
      toast_description: "Merchandise Listing",
      share_text: "Buy my product",
    },
    {
      name: schedule_type_names[schedule_types_ids.rolling_class],
      id: schedule_types_ids.rolling_class,
      toast_description:
        "Weekly repeating schedules for all your classes. Collect monthly or one-time payments.",
      share_text: "Join my class",
    },
    {
      name: schedule_type_names[schedule_types_ids.telegram],
      id: schedule_types_ids.telegram,
      toast_description:
        "Create Telegram communities and enable membership rules.",
      share_text: "Join my telegram",
    },
    {
      name: schedule_type_names[schedule_types_ids.webinar],
      id: schedule_types_ids.webinar,
      toast_description: "Host interactive webinars in front of a big audience",
      share_text: "Join my webinars",
    },
    {
      name: schedule_type_names[schedule_types_ids.whatsapp],
      id: schedule_types_ids.whatsapp,
      toast_description: "Create a Whatsapp group community and drive growth.",
      share_text: "Buy my WhatsApp",
    },
    {
      name: schedule_type_names[schedule_types_ids.branded_community],
      id: schedule_types_ids.branded_community,
      toast_description:
        "Create engaging member communities and upsell your offerings.",
      share_text: "Join my Community",
    },
  ],
  scheduleTypesId: schedule_types_ids, // TODO: replace every usage of LHS with RHS
  courseDurationTypes: {
    WEEKS: 1,
    MONTHS: 2,
    SESSIONS: 3,
  },
  courseDurationLabels: {
    1: "Weeks",
    2: "Months",
    3: "Sessions",
  },
  lead_reasons: [
    { name: "Get in Touch on Offering Page", id: 0 },
    { name: "Get in Touch", id: 1 },
    { name: "Exit lead capture form on Offering Page", id: 2 },
    { name: "Exit lead capture form", id: 3 },
    { name: "Payment Failed", id: 4 },
    { name: "Payment Initiated", id: 5 },
    { name: "Booked a Demo Session", id: 6 },
    { name: "Requested to be contacted", id: 20 },
  ],
  dispatchStatus: {
    PENDING: 1,
    DISPATCHED: 2,
    DELIVERED: 3,
  },
  product_dispatch_status: [
    {},
    { name: "To Be Dispatched", className: "text-warning", id: 1 },
    { name: "Dispatched", className: "text-success", id: 2 },
    { name: "Delivered", className: "text-success", id: 3 },
  ],
  referral_status: {
    NOT_SIGNED_UP: { className: "text-danger", id: 0 },
    CONVERTED: { className: "text-success", id: 1 },
    Active: { className: "text-success", id: 2 },
    SIGNED_UP: { className: "text-success", id: 3 },
  },
  referral_link: "https://exlyapp.com/home/refer-exly/",
  /** @deprecated use INR from src/features/Listings/Listings.constants.js */
  inr: "INR",
  inr_currency: "₹",
  /** @deprecated use USD from src/features/Listings/Listings.constants.js */
  usd: "USD",
  usd_currency: "$",
  discountCard: {
    title: "Create discount codes.",
    description: [
      "Set a discount value and create a discount code name",
      "Set a usage limit for the code",
      "Customers will use the discount code to get the set discount on any of your offerings",
    ],
  },
  CURRENCY_SYMBOL_MAP: {
    INR: "₹",
    USD: "$",
    EUR: "€",
    GBP: "£",
    CAD: "CA$",
    AED: "د.إ",
    AUD: "AU$",
    IDR: "Rp",
    SAR: "SR",
    ARS: "AR$",
    TTD: "TT$",
    NGN: "₦",
    PKR: "PKRs",
    MUR: "MURs",
    MMK: "K",
    EGP: "EGP",
    HUF: "Ft",
    ZAR: "R",
    PHP: "₱",
    THB: "฿",
    SGD: "S$",
    KHR: "KHR",
    LAK: "₭",
    BDT: "Tk",
    MYR: "RM",
  },
  listing_status: [
    {},
    { name: "Live", id: 1 },
    { name: "In Waitlist", id: 2 },
    { name: "Expired", id: 3 },
    {},
    { name: "Deleted", id: 5 },
  ],
  GST_STATUS: GST_STATUS_CONSTS, // TODO: replace every LHS with RHS
  LEAD_STATUS: {
    1: {
      name: "New Lead",
      slug: "ADDED",
      id: 1,
      description:
        "You can change the status of the leads you have reached depending on their response",
      color: "#1F04C5",
    },
    2: {
      name: "Converted Lead",
      slug: "CONVERTED",
      id: 2,
      description: "Lead has made their first booking/purchase",
      color: "#1f890e",
    },
    3: {
      name: "No response",
      slug: "NO_RESPONSE",
      id: 3,
      description:
        "You can change the status of the leads you have reached depending on their response",
      color: "#000",
    },
    4: {
      name: "Interested",
      slug: "INTERESTED ",
      id: 4,
      description:
        "You can change the status of the leads you have reached depending on their response",
      color: "#000",
    },
    5: {
      name: "Not interested",
      slug: "NOT_INTERESTED ",
      id: 5,
      description:
        "You can change the status of the leads you have reached depending on their response",
      color: "#000",
    },
  },
  leads_dashboard: {
    amount: {
      title: "Revenue from lead conversions",
      description:
        "Total money generated from first-ever bookings made by leads",
    },
    converted: {
      title: "Leads converted",
      description:
        "Number of leads that have booked/purchased at least one offering.",
    },
    leads: {
      title: "Leads captured",
      description:
        "Number of people who have shown interest in your offerings. This number includes all leads - New and Converted.",
    },
    interested: {
      title: "Leads engaged",
      description:
        "Number of leads that are marked interested (by you) or are potential converted leads",
    },
  },
  pricing_mode_monthly: 2,
  pricing_mode_once: 1,
  batch_change_enum: {
    no_change: 0,
    modified: 1,
    added: 2,
  },
  exly_inv_template: "exly_invite_leads",
  payout_status: {
    "Added Booking/Purchase": { color: "#1F04C5" },
    Processed: { color: "#1f890e" },
    Failed: { color: "#df635d" },
    Pending: { color: "#fb0" },
  },
  max_attachments_size: 5242880,
  // @dev - These AWS creds along with the relevant bucket DEPRECTAED_S3_BUCKET_STAGING_MYSCOOT_DOCS are deprecated and should not be used.
  AWS_CRED: {
    accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_S3_SECRET_ACCESS_KEY,
    region: process.env.REACT_APP_S3_REGION,
  },
  RECORDED_CONTENT_UPLOAD_AWS_CRED: {
    accessKeyId: process.env.REACT_APP_EXLY_S3_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_EXLY_S3_SECRET_ACCESS_KEY,
    region: process.env.REACT_APP_S3_REGION,
  },
  DEPRECTAED_S3_BUCKET_STAGING_MYSCOOT_DOCS: process.env.REACT_APP_S3_BUCKET,
  AWS_ATTACHMENT_BUCKET: process.env.REACT_APP_S3_ATTACHMENT_BUCKET,
  progress_status: {
    final: 90,
    inBetween: 60,
    initial: 30,
  },
  staff_type: {
    1: { name: `Main${"\u00A0"}user` },
    2: { name: "Staff" },
  },
  testimonial_type: {
    text: 1,
    image: 2,
    video: 3,
  },
  contact_modes: [
    { id: "Whatsapp", title: "WhatsApp" },
    { id: "Telegram", title: "Telegram" },
    { id: "none", title: `Don't want to be contacted` },
  ],
  STAFF_ROLES: {
    MAIN: 0,
    OWNER: 1,
    MANAGER: 2,
    SUPPORT: 3,
    PRIMARY_STAFF: 4,
    SECONDARY_STAFF: 5,
    TERTIARY_STAFF: 6,
  },
  STAFF_ROLL_STRINGS: {
    0: "mainUser",
    1: "owner",
    2: "manager",
    3: "support",
    4: "primary",
    5: "secondary",
    6: "tertiary",
  },
  indian_country_code: "+91",
  us_country_code: "+1",
  india_country_name: "India",
  us_country_name: "United States",
  indian_timezone: "Asia/Kolkata",
  usa_billing_states: [
    { name: "Alabama" },
    { name: "Alaska" },
    { name: "Arizona" },
    { name: "Arkansas" },
    { name: "California" },
    { name: "Colorado" },
    { name: "Connecticut" },
    { name: "Delaware" },
    { name: "District of Columbia" },
    { name: "Florida" },
    { name: "Georgia" },
    { name: "Hawaii" },
    { name: "Idaho" },
    { name: "Illinois" },
    { name: "Indiana" },
    { name: "Iowa" },
    { name: "Kansas" },
    { name: "Kentucky" },
    { name: "Louisiana" },
    { name: "Maine" },
    { name: "Maryland" },
    { name: "Massachusetts" },
    { name: "Michigan" },
    { name: "Minnesota" },
    { name: "Mississippi" },
    { name: "Missouri" },
    { name: "Montana" },
    { name: "Nebraska" },
    { name: "Nevada" },
    { name: "New Hampshire" },
    { name: "New Jersey" },
    { name: "New Mexico" },
    { name: "New York" },
    { name: "North Carolina" },
    { name: "North Dakota" },
    { name: "Ohio" },
    { name: "Oklahoma" },
    { name: "Oregon" },
    { name: "Pennsylvania" },
    { name: "Rhode Island" },
    { name: "South Carolina" },
    { name: "South Dakota" },
    { name: "Tennessee" },
    { name: "Texas" },
    { name: "Utah" },
    { name: "Vermont" },
    { name: "Virginia" },
    { name: "Washington" },
    { name: "West Virginia" },
    { name: "Wisconsin" },
    { name: "Wyoming" },
  ],
  success_color: "#1f890e",
  gallery_module: "gallery",
  transaction_module: "transaction",
  testimonial_module: "testimonial",
  member_module: "member",
  international_region: 1,
  domestic_region: 0,
  pre_nameservers_linking: 5,
  nameservers_link_confirmation: 20,
  domain_linked: 100,
  max_domestic_price: max_domestic_price,
  max_domestic_autodebit_price: max_domestic_autodebit_price,
  min_domestic_autodebit_price: min_domestic_autodebit_price,
  max_international_price: max_international_price,
  current_month: "current_month",
  previous_month: "previous_month",
  error_message: "Something went wrong!",
  mediaType: recorded_content_media_types, // TODO: replace LHS everywhere with RHS
  mediaStatus: {
    active: 1,
    archived: 2,
  },
  no_schedule_course_end_choices: no_schedule_course_end_choices, // TODO: replace LHS everywhere with RHS
  bonusRevenueOffer: "25% Bonus Revenue Offer",
  joiningOffer: ["Get 25% Bonus Revenue on Bookings Done Within 7 Days"],
  dashboardFilter: {
    last7days: 7,
    last30days: 30,
    lastMonthValue: "last month",
    allTime: 90,
    custom: "custom",
  },
  domesticDateFormat: "dd/MM/yyyy",
  internationalDateFormat: "MMMM dd, yyyy",
  domesticInputDateTimeFormat: "DD/MM/YYYY HH:mm",
  internationalInputDateTimeFormat: "MMMM DD, YYYY HH:mm",
  internationalInputDateTimeFormatWithSaparation: "MMM DD, YYYY | hh:mm A",
  displayDateYearTimeFormat: `MMMM DD, YYYY, ${DEFAULT_TIME_FORMAT_12}`,
  displayDateTimeFormat: `MMMM DD, ${DEFAULT_TIME_FORMAT_12}`,
  displayDateYearFormat: "MMMM DD, YYYY",
  displayDateNoYear: "MMMM DD",
  blogsMomentDateTimeFormat: `ddd, MMM Do, YYYY ${DEFAULT_TIME_FORMAT_12}`,
  csvInputDateFormat: "DD/MM/YYYY",
  ISODateFormat: "YYYY-MM-DD",
  commentStatus: {
    ACTIVE: 1,
    HIDDEN: 2,
    INACTIVE: 3,
  },
  listing_review_status: {
    draft: 1,
    live: 2,
    hidden: 3,
  },
  listing_review_source: {
    admin_pannel: 1,
    creator_tool: 2,
  },
  error: {
    positiveIntgersAllowed: "Only positive & non-decimal numbers are allowed",
  },
  steps_flags: {
    has_whatsapp_campaign: "has_whatsapp_campaign",
    has_custom_email: "has_custom_email",
    has_manage_recording: "has_manage_recording",
  },
  creator_subscription_status: [
    { id: 0, name: "Active" },
    { id: 1, name: "Pending" },
    {},
    {},
    { id: 4, name: "Expired" },
  ],
  segments_target_type: {
    customers: 1,
    leads: 2,
  },
  entity_type: {
    customers: {
      value: 2,
      label: "Customer",
    },
    leads: {
      value: 1,
      label: "Leads",
    },
  },
  avaibility_type: {
    not_decided: 4,
    custom: 3,
  },
  add_question_validator: {
    question_title: {
      minlength: "Question must be atleast 3 characters",
      maxLength: "Question must be atmost 100 characters",
    },
  },
  duration: {
    custom: {
      id: 5,
      value: "",
    },
  },
  leadType: {
    webpageLead: 1,
    adLead: 2,
  },
  extra: "extra",
  plan_recurrence_type: {
    MONTHLY: 1,
    YEARLY: 2,
  },
  per_page_options: [
    PER_PAGE_OPTIONS_50,
    PER_PAGE_OPTIONS_100,
    PER_PAGE_OPTIONS_250,
  ],
  whatsappPaymentCycle: {
    1: "Week",
    2: "Month",
    3: "Day",
  },
  support_email: "support@exlyapp.com",
  product_email: "product@myscoot.in",
  export_recipient_headers: [
    "Recipient name",
    "Recipient phone number",
    "Recipient email id",
    "Attempted at",
    "Sent at",
  ],
  export_recipient_headers_whatsapp: [
    "Recipient name",
    "Recipient phone number",
    "Attempted at",
    "Sent at",
  ],
  export_recipient_headers_email: [
    "Recipient name",
    "Recipient email id",
    "Attempted at",
    "Sent at",
  ],
};

export default constants;
